import { render } from "./KmmFooter.vue?vue&type=template&id=19d9d940&scoped=true"
import script from "./KmmFooter.vue?vue&type=script&lang=js"
export * from "./KmmFooter.vue?vue&type=script&lang=js"

import "./KmmFooter.vue?vue&type=style&index=0&id=19d9d940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d9d940"]])

export default __exports__